export function Avatar({ user, size = "md" }) {
  const initials = (user?.name || user?.email || "").split(" ").filter(Boolean).slice(0, 2).map((name) => name[0]).join("").toUpperCase();
  return user?.avatar ? (
    <img className={`avatar avatar-${size}`} src={user.avatar} alt={`Foto de ${user.name}`} loading="lazy" decoding="async" data-testid={`avatar-${user.id || "current"}`} />
  ) : (
    <span className={`avatar avatar-${size} avatar-empty`} data-testid={`avatar-${user?.id || "current"}`}>{initials || ""}</span>
  );
}
